import { FormApiMethodsRequestData } from '../../../api/types/types';
import { DatasetControl } from '../../../types/types';
import { getFormTypeFromPathname } from '../../../utils/forms/getFormTypeFromPathname';
import { useFormTokenChainContext } from '../../context/useFormTokenChainContext';

export const createRootTokenByFormType = (
  formActionUrl: string,
  fromPathname: string,
  fromItemExternalUrl: boolean | undefined,
  control: DatasetControl,
  // Only row ids — full row objects blow up localStorage (whole token tree is persisted)
  rowIds: string[],
  requestData: FormApiMethodsRequestData,
  createRootToken: ReturnType<
    typeof useFormTokenChainContext
  >['createRootToken']
) => {
  const formType = getFormTypeFromPathname(formActionUrl);
  const controlSelectionMode = control.selectionMode || 'dontcare';

  if (formType === 'edit' || formType === 'copy') {
    return createRootToken({
      url: formActionUrl,
      fromUrl: fromPathname,
      meta: {
        controlLabel: control.label,
        // Store ids only; consumer rehydrates minimal stub rows on read
        rowsToUse: rowIds,
        requestData,
        // Carried so the form can suppress paginator/save-and-next for 'dontcare'
        controlSelectionMode,
        enteredFromExternalUrl: fromItemExternalUrl,
      },
    });
  }

  if (formType === 'insert') {
    return createRootToken({
      url: formActionUrl,
      fromUrl: fromPathname,
      meta: {
        controlLabel: control.label,
        requestData,
        controlSelectionMode,
        enteredFromExternalUrl: fromItemExternalUrl,
      },
    });
  }

  return createRootToken({
    url: formActionUrl,
    fromUrl: fromPathname,
    meta: {
      controlLabel: control.label,
      requestData,
      controlSelectionMode,
      enteredFromExternalUrl: fromItemExternalUrl,
    },
  });
};
